'use client';

import { useEffect } from 'react';

import { posthog } from '@/instrumentation-client';
import { useConsent } from '@/lib/contexts/consent/ConsentProvider';

import { useAnalytics } from './useAnalytics';

export const useAnalyticsConsentSync = () => {
  const { registerContext, resetCount } = useAnalytics();
  const { hasConsent, consentVersion } = useConsent();

  useEffect(() => {
    const analyticsAllowed = hasConsent('analytics');

    if (analyticsAllowed) {
      posthog.opt_in_capturing();
    } else {
      posthog.opt_out_capturing();
    }

    registerContext({
      consent: {
        analytics: analyticsAllowed ? 'GRANTED' : 'DENIED',
      },
    });
  }, [registerContext, hasConsent, consentVersion, resetCount]);
};
